/* global swal*/
import './style.less';
import { orderBy, get } from 'lodash';

export default function($scope, $state, $q, $stateParams, $log, Swal, ApiClass, ProfileClass) {
  'ngInject';

  const qArr = [
    ProfileClass.profileComplete,
  ];

  const vm = this;

  vm.profile_uid = $stateParams.id;

  vm.$onInit = activate;

  vm.activateTrack = track => {
    Swal.confirm('Publish Learning Track?', 'This will make the learning track viewable to users.')
      .then(() => {
        const { track_id } = track;
        return ApiClass.learningsIdPatch(
          { id: track_id },
          { track_id, active: true },
          { queryParams: { manage: true } }
        );
      })
      .then(() => {
        track.active = true;
        Swal.toast('Published learning track');
      })
      .catch(error => {
        if (error.dismiss) return;
        $log.error(error);
        throw error;
      });
  };

  vm.deactivateTrack = track => {
    Swal.confirm('Unpublish Learning Track?', 'This will make the learning track not viewable to users.')
      .then(() => {
        const { track_id } = track;
        return ApiClass.learningsIdPatch(
          { id: track_id },
          { track_id, active: false },
          { queryParams: { manage: true } }
        );
      })
      .then(() => {
        track.active = false;
        Swal.toast('Unpublished learning track');
      })
      .catch(error => {
        if (error.dismiss) return;
        $log.error(error);
        throw error;
      });
  };

  vm.archiveTrack = (track_id, index) => {
    Swal.confirm('Archive Learning Track?', 'This will remove the learning track from all users.')
      .then(() => {
        return ApiClass.learningsIdPatch(
          { id: track_id },
          { track_id, archive: true },
          {
            queryParams: {
              manage: true
            }
          }
        );
      })
      .then(() => {
        activate();
        Swal.toast('Archived learning track');
      })
      .catch(error => {
        if (error.dismiss) return;
        $log.error(error);
        throw error;
      });
  };

  vm.addTrack = () => $state.go('app.admin.learning.track', { id: vm.profile_uid, track_id: '' });

  function activate() {
    $log.debug('Admin Learning Controller Activated');

    vm.loaded = false;
    vm.error = {};

    $q.all(qArr)
      .then(([profileComplete]) => {
        $scope.disableButtons = get(profileComplete, 'company.preferences.read_only.admin.learning', false);
      });

    return ApiClass.learningsGet({}, {}, { queryParams: { manage: true } })
      .then(({ data: { tracks } }) => {
        tracks = tracks.map(track => {
          if (!track.updates) return track;
          let temp_date = new Date();

          if (track.updates && track.updates.length) {
            temp_date = track.updates.reverse()[0].date || track.updates.reverse()[0].time;
          }
          track.sortDate = new Date(temp_date).getTime();
          return track;
        });
        vm.tracks = orderBy(tracks, ['name'], ['asc']);
        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = {
          status: true,
          refresh: activate
        };
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/admin/learningTracks/manager/controller.js